import React from "react";
import { ThemeProvider } from "@mui/material";
import asonikaTheme from "../theme";

export function WithTheme<TProps extends {} = {}>(
  Child: React.ComponentType<TProps>
) {
  return (props: TProps) => (
    <ThemeProvider theme={asonikaTheme}>
      <Child {...props} />
    </ThemeProvider>
  );
}
